import type { NftData } from '@mogul/api-client/src/api';
import { useEffect, useState } from 'react';

import { getNftIfMinted } from '../api-helpers/nft';

export interface NftAsset {
  id: string;
  storageKey: string;
  mimeType: string;
  publicUrl: string;
}

export interface Nft extends NftData {
  animation?: NftAsset;
  animationOriginal?: NftAsset;
  image?: NftAsset;
  imageOriginal?: NftAsset;
  imagePreview?: NftAsset;
}

export const useGetNft = (contractAddress: string, id: string) => {
  const [nft, setNft] = useState<Nft | null>(null);

  useEffect(() => {
    void (async () => {
      const _nft = await getNftIfMinted(contractAddress, id);

      if (!_nft) {
        return;
      }

      setNft(_nft);
    })();
  }, []);

  return nft;
};
